import { ErrorHandler, Injectable } from '@angular/core';
import { createErrorHandler } from '@sentry/angular';

const chunkFailedMessage = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk [\d]+ failed/i;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryHandler = createErrorHandler({ showDialog: false });

  handleError(error: unknown): void {
    // A failed lazy chunk means the deployed build changed under the user — offer a reload to
    // fetch the fresh index, and skip Sentry (it's deploy churn, not a bug).
    if (chunkFailedMessage.test((error as Error)?.message)) {
      if (typeof window !== 'undefined' && confirm('A new version is available! Would you like to load it now?')) {
        window.location.reload();
      }
      return;
    }
    this.sentryHandler.handleError(error);
  }
}
